/**
 * Append to a capped list. Used for the Add Pedal photo picker, where the
 * files and their preview URLs live in two parallel arrays that must change
 * together: both updaters append through this with the same cap, so when two
 * picks overlap (drop, then drop again before the first batch's file copies
 * resolve) both arrays truncate at the same index and stay aligned. The
 * previous version computed the room from a ref read after an await, so two
 * overlapping adds both saw the same room and could pass the cap (2026-11-01
 * review).
 */
export function appendWithCap(prev, additions, cap) {
  const base = Array.isArray(prev) ? prev : [];
  const extra = Array.isArray(additions) ? additions : [];
  if (extra.length === 0) return base;
  return [...base, ...extra].slice(0, cap);
}
